import validatorjs from 'validatorjs';
import { FormBase } from 'core/components';

export default class ProductPartForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'productId',
					label: 'PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.PRODUCT',
					rules: 'required',
				},
				{
					name: 'quantity',
					label: 'PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.QUANTITY',
					rules: 'required|numeric|numericMinValue|notZero|integer',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/product/forms/ProductPartForm.js